export default "__VITE_ASSET__Cg58AoFb__"